// extracted by mini-css-extract-plugin
export var active = "_b9-d";
export var blink = "_b9-e";
export var container = "_b9-5";
export var controls = "_b9-0";
export var controlsRight = "_b9-1";
export var fakeCursor = "_b9-c";
export var hidden = "_b9-b";
export var quillContainerSmall = "_b9-7";
export var quillEditor = "_b9-6";
export var quillEditorSmall = "_b9-8";
export var quillFormatButtons = "_b9-a";
export var quillToolbar = "_b9-9";
export var removePadding = "_b9-2";
export var state = "_b9-3";
export var stateTitle = "_b9-4";